// extracted by mini-css-extract-plugin
export default {"projectSelector":"Selector_projectSelector__MyDAX","prompt":"Selector_prompt__DG7ZV","prompts":"Selector_prompts__+lZ9v"};